import ConfirmNavigate from "./ConfirmNavigate";
import * as ReactDOM from "react-dom";
import * as React from "react";
import {theme} from "colors";
import Theme from "components/Theme";

const getUserConfirmation = (message: any, callback: any) => {
    const app = document.getElementById("app");
    const modal = document.createElement("div");
    app.appendChild(modal);

    const withCleanup = (answer: any) => {
        callback(answer);
        setTimeout(() => {
            // give the close animation time
            ReactDOM.unmountComponentAtNode(modal);
            app.removeChild(modal);
        }, 500);
    };

    ReactDOM.render(
        // we HAVE to explicitly set the theme here or this doesn't work
        <Theme theme={theme}>
            <ConfirmNavigate message={message} callback={withCleanup} />
        </Theme>
        , modal);
};

export default getUserConfirmation;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ConfirmNavigate/getUserConfirmation.tsx